export default __webpack_public_path__ + "static/media/id-card-back.7bd8d65e.jpg";